import { Dropdown, Menu } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import Icons from "components/icons";

const BookingActionField = ({ booking, text, disabled, onEdit, onDelete }) => (
    <Dropdown placement="bottomRight" overlayClassName="drop-more-menu" arrow
        trigger={ ["hover", "click"] } disabled={ disabled }
        overlay={ <Menu items={ [
            { key: "edit", label: text("Edit"), icon: <Icons.Edit />, disabled, onClick: onEdit },
            { key: "delete", label: text("Delete"), icon: <Icons.Delete />, disabled, onClick: onDelete },
        ] } /> }>
        <button type="button" className="btn-more booked-subcontractors__actions" disabled={ disabled }
            aria-label={ `${text("Actions")}: ${booking.relSubcontractor?.title || text("Unavailable")}` }>
            <EllipsisOutlined />
        </button>
    </Dropdown>
);

export default BookingActionField;
